import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/*
 * Preloads only routes explicitly flagged with `data: { preload: true }` in the background
 * after the initial bundle finishes loading, instead of Angular's all-or-nothing choices
 * (NoPreloading leaves every lazy chunk to load on first navigation; PreloadAllModules would
 * download all ~130 lazy chunks regardless of whether the user ever visits them).
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    // biome-ignore lint/complexity/useLiteralKeys: tsconfig's noPropertyAccessFromIndexSignature requires bracket notation here
    return route.data?.['preload'] ? load() : of(null);
  }
}
